import * as React from 'react'
import { ArrowRightOnRectangleIcon as LogoutIcon } from '@heroicons/react/24/outline'
import { OutlineButton } from '../Common/OutlineButton'

interface LogoutButtonProps {
  onClick: () => void
  className?: string
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ onClick, className }) => (
  <OutlineButton
    onClick={onClick}
    icon={<LogoutIcon className="h-4 w-4" />}
    className={className}
  >
    Wyloguj się
  </OutlineButton>
)

export default LogoutButton
